import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ExperiencePageProps {
  company: string;
  role: string;
  period: string;
  description: string[];
}

const ExperiencePage: React.FC<ExperiencePageProps> = ({
  company,
  role,
  period,
  description,
}) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Button onClick={() => navigate('/')} variant="outlined" sx={{ mb: 3 }}>
        Back to Home
      </Button>
      
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom>
          {company}
        </Typography>
        
        <Typography variant="h5" color="primary" gutterBottom>
          {role}
        </Typography>
        
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          {period}
        </Typography>

        <Box sx={{ my: 4 }}>
          <Typography variant="h6" gutterBottom>
            Experience
          </Typography>
          {description.map((point, index) => (
            <Typography key={index} variant="body1" paragraph>
              • {point}
            </Typography>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default ExperiencePage;
